import './App.css';
import PhotoUploader from "./components/PhotoUploader";
import {createBrowserRouter, RouterProvider} from "react-router-dom";


const router = createBrowserRouter([
    {
        path: "/",
        element: <div>Hello world!</div>,
    }, {
        path: "/upload/:folderId",
        element: <PhotoUploader/>
    },
]);

function App() {
    return (
        <div className="App">
            <RouterProvider router={router}/>
        </div>
    );
}

export default App;
